import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import WorkbookImageUploadModal from '@/components/ui/upload/WorkbookImageUploadModal';

interface PrivateImageUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  workbookId: string;
}

const PrivateImageUploadModal: React.FC<PrivateImageUploadModalProps> = ({
  isOpen,
  onClose,
  workbookId,
}) => {
  const queryClient = useQueryClient();

  const handleImageUploaded = (imageUrl: string, altText?: string) => {
    // Image is already saved to database by WorkbookImageUploadModal
    // Just refresh the private library and close modal
    queryClient.invalidateQueries({ queryKey: ['private-image-library', workbookId] });
    queryClient.invalidateQueries({ queryKey: ['private-image-library-count', workbookId] });
    
    // Close the modal - no editor injection needed
    onClose();
  };

  return (
    <WorkbookImageUploadModal
      isOpen={isOpen}
      onClose={onClose}
      onImageUploaded={handleImageUploaded}
      workbookId={workbookId}
      // No pageId needed for private library context
    />
  );
};

export default PrivateImageUploadModal; 